import React from 'react'
import { Project, ProjectCreate } from '../api/client'

interface ProjectFormProps {
  project: ProjectCreate | Project
  setProject: React.Dispatch<React.SetStateAction<any>>
  onSubmit: (e: React.FormEvent) => Promise<void>
  isEditing?: boolean
  onCancel?: () => void
  submitButtonText?: string
  isSubmitting?: boolean
}

const ProjectForm: React.FC<ProjectFormProps> = ({
  project,
  setProject,
  onSubmit,
  isEditing = false,
  onCancel,
  submitButtonText = 'Save',
  isSubmitting = false
}) => {
  return (
    <form onSubmit={onSubmit}>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="col-span-2">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Title*
          </label>
          <input
            type="text"
            value={project.title}
            onChange={(e) => setProject({...project, title: e.target.value})}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-action"
            required
          />
        </div>
        
        <div className="col-span-2">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Description
          </label>
          <textarea
            value={project.description || ''}
            onChange={(e) => setProject({...project, description: e.target.value})}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-action"
            rows={3}
          />
        </div>

        <div className="col-span-2">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Emoji
          </label>
          <input
            type="text"
            value={project.emoji || ''}
            onChange={(e) => setProject({...project, emoji: e.target.value})}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-action"
            placeholder="e.g., 🚀, 🏋️, 📚"
            maxLength={2}
          />
        </div>

        <div className="col-span-2 flex justify-end gap-3 mt-4">
          {isEditing && onCancel && (
            <button
              type="button"
              onClick={onCancel}
              className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
            >
              Cancel
            </button>
          )}
          <button
            type="submit"
            disabled={isSubmitting}
            className={`bg-action text-plum px-4 py-2 rounded-md hover:bg-action-dark flex items-center ${
              isSubmitting ? 'opacity-50 cursor-not-allowed' : ''
            }`}
          >
            {isSubmitting ? (
              <>
                <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                Creating...
              </>
            ) : submitButtonText}
          </button>
        </div>
      </div>
    </form>
  )
}

export default ProjectForm